module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail",
    class: {
      'mini-width': _vm.miniWidth
    }
  }, [_c('div', {
    staticClass: "head"
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [(_vm.isBad && _vm.status === 6) ? _c('div', {
    staticClass: "chapter"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/bad.png")
    }
  })]) : (_vm.isBad && _vm.status === 7) ? _c('div', {
    staticClass: "chapter"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/badpart.png")
    }
  })]) : (_vm.isCancel) ? _c('div', {
    staticClass: "chapter"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/imgs/cancel.png")
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "text",
    class: {
      red: _vm.isRed
    }
  }, [_vm._v(_vm._s(_vm.header.title))]), _vm._v(" "), (['customerApi', 'opportunityApi'].indexOf(_vm.moduleName) > -1) ? [_c('i', {
    staticClass: "el-star",
    class: [_vm.isFocus ? 'el-icon-star-on' : 'el-icon-star-off'],
    on: {
      "click": _vm.handleFocus
    }
  })] : _vm._e(), _vm._v(" "), (_vm.header.tags) ? _c('div', {
    staticClass: "tag-list"
  }, _vm._l((_vm.header.tags), function(tag, index) {
    return _c('el-tooltip', {
      key: index,
      attrs: {
        "content": tag.memo,
        "placement": "bottom",
        "effect": "light"
      }
    }, [_c('span', {
      staticClass: "tag",
      class: 'tagbg-' + tag.tagType
    }, [_vm._v("\n              " + _vm._s(tag.tagName) + "\n            ")])])
  })) : _vm._e()], 2)]), _vm._v(" "), (_vm.phoneList.length) ? _c('div', {
    staticClass: "cti-btn"
  }, [_c('i', {
    staticClass: "web-icon-dial",
    on: {
      "click": _vm.makeCall
    }
  })]) : _vm._e(), _vm._v(" "), (['bomBill'].indexOf(_vm.moduleName) > -1 && _vm.header.isShow) ? [_c('el-checkbox', {
    on: {
      "change": _vm.changeBomVersion
    },
    model: {
      value: (_vm.header.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.header, "isDefault", $$v)
      },
      expression: "header.isDefault"
    }
  }, [_vm._v("设为默认版本")])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-items"
  }, [(_vm.permission && _vm.permission.length) ? _c('el-button-group', _vm._l((_vm.permission), function(btn) {
    return _c('el-button', {
      key: btn,
      class: _vm.menuType[btn].icon,
      attrs: {
        "icon": 'el-icon-' + _vm.menuType[btn].icon
      },
      on: {
        "click": function($event) {
          _vm.handleBtn(btn)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.menuType[btn].name) + "\n        ")])
  })) : _vm._e(), _vm._v(" "), _vm._m(0)], 1)], 2), _vm._v(" "), (_vm.header.secondTitle) ? _c('div', {
    staticClass: "desc"
  }, _vm._l((_vm.header.secondTitle), function(value, key) {
    return _c('span', {
      key: value + key,
      staticClass: "text"
    }, [_vm._v(_vm._s(key) + "：" + _vm._s(value))])
  })) : _vm._e(), _vm._v(" "), (_vm.moduleName === 'customerApi' && _vm.customerStage.allStageArray && _vm.customerStage.allStageArray.length) ? _c('customer-stage-flow', {
    attrs: {
      "customerStage": _vm.customerStage,
      "customerId": _vm.id,
      "customerType": _vm.customerType
    },
    on: {
      "openLoseBecause": function($event) {
        _vm.loseBecauseShow = true
      },
      "createContract": _vm.createContract,
      "refresh": _vm.refreshCustomerStage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.opportunity) ? _c('div', {
    staticClass: "oppo-desc"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.handleTransfer('customerApi', _vm.opportunity.baseTitle.customerId)
      }
    }
  }, [_vm._v(_vm._s(_vm.opportunity.baseTitle.customerName))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("预计金额：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.opportunity.baseTitle.estimateAmount))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("停留时长：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.opportunity.baseTitle.lastedtime))])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v("预计结束日期：")]), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.opportunity.baseTitle.estimateEndTime))])])]) : _vm._e(), _vm._v(" "), (_vm.opportunity) ? _c('div', {
    staticClass: "oppo-stage"
  }, [_c('ul', {
    staticClass: "stage-list",
    class: {
      disable: _vm.opportunity.nowType > 1
    }
  }, [_vm._l((_vm.opportunity.allStageArray), function(item, index) {
    return [(item.type === 2) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.opportunity.nowType),
        expression: "!opportunity.nowType"
      }],
      staticClass: "option"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.jumpConfirm(item, true)
        }
      }
    }, [_vm._v("输单")])]) : (item.type === 3) ? _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.opportunity.nowType),
        expression: "!opportunity.nowType"
      }],
      staticClass: "option"
    }, [_c('a', {
      staticClass: "link cancel",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.jumpConfirm(item)
        }
      }
    }, [_vm._v("取消")])]) : _c('li', {
      staticClass: "item",
      class: {
        'progress': item.sort >= _vm.opportunity.nowSort && _vm.opportunity.nowType <= 1 && _vm.opportunity.nowSort !== null
      },
      on: {
        "click": function($event) {
          _vm.changeStage(item)
        }
      }
    }, [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.stageName))]), _vm._v(" "), (item.sort >= _vm.opportunity.nowSort) ? _c('ul', {
      staticClass: "mini-modal"
    }, [_c('li', {
      staticClass: "p break-all"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("第 " + _vm._s(index + 1) + " 阶段：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.stageName) + "（赢率" + _vm._s(item.estimateWinRate) + "%）")])]), _vm._v(" "), _c('li', {
      staticClass: "p"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("阶段用时：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.usedDay))])]), _vm._v(" "), _c('li', {
      staticClass: "p"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("经历阶段：")]), _vm._v(" "), _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.intoTime) + "~" + _vm._s(item.outTime))])])]) : _vm._e()])]
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opportunity.nowType),
      expression: "opportunity.nowType"
    }],
    staticClass: "lastedtime"
  }, [_vm._v("总历时：" + _vm._s(_vm.opportunity.baseTitle.lastedtime))])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(['productApi'].indexOf(_vm.moduleName) === -1) ? _c('div', {
    staticClass: "con-left"
  }, [(_vm.workFlow.length) ? _c('div', {
    staticClass: "entry"
  }, _vm._l((_vm.workFlow), function(item) {
    return _c('el-button', {
      key: item.title,
      attrs: {
        "disabled": item.id === -2
      },
      on: {
        "click": function($event) {
          _vm.handleTransfer(item.key, item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })) : _vm._e(), _vm._v(" "), (['customerApi', 'opportunityApi', 'contractApi', 'workOrder', 'supplier', 'purchase', 'bomBill', 'productionOrder'].indexOf(_vm.moduleName) > -1 && !_vm.isPublic && _vm.routeChild !== 'isDel') ? _c('sale-team', {
    attrs: {
      "id": _vm.id,
      "moduleName": _vm.moduleName
    },
    on: {
      "refresh": _vm.getList
    }
  }) : _vm._e(), _vm._v(" "), _c('basic-item', {
    attrs: {
      "detailData": _vm.detailData,
      "otherDetail": _vm.otherDetail,
      "rates": _vm.rates,
      "origin": _vm.origin,
      "moduleName": _vm.moduleName
    },
    on: {
      "openDetail": _vm.handleTransfer
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("供应商评分")])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con-right",
    class: _vm.moduleName,
    style: (['productApi'].indexOf(_vm.moduleName) > -1 ? 'width:100%' : 'width:665px')
  }, [(_vm.tabCon && _vm.tabCon.length) ? [_c('div', {
    staticClass: "tab-two"
  }, [_c('el-tabs', {
    attrs: {
      "value": _vm.currentView
    },
    on: {
      "tab-click": _vm.tabClick
    }
  }, [_vm._l((_vm.tabCon), function(tab) {
    return [_c('el-tab-pane', {
      key: tab.module,
      attrs: {
        "label": tab.title,
        "name": tab.module
      }
    })]
  })], 2)], 1), _vm._v(" "), (_vm.childrenShow) ? _c('div', {
    ref: "conRight",
    staticClass: "tab-con"
  }, [_c('keep-alive', {
    attrs: {
      "include": "fileCabinet"
    }
  }, [_c(_vm.currentView, {
    ref: _vm.currentView,
    tag: "component",
    attrs: {
      "id": _vm.id,
      "loading": _vm.scrollData,
      "moduleName": _vm.moduleName,
      "refresh": _vm.reCommunicate,
      "superBtn": _vm.superBtn
    },
    on: {
      "refresh": _vm.refreshCustomerStage,
      "openSupplierAddNew": _vm.supplierAddNew,
      "openDetail": _vm.handleTransfer,
      "createContract": _vm.createContract
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.currentView === 'workorderDynamic') ? _c('div', {
    staticClass: "dynamic-warp"
  }, [_c('add-dynamic', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "update": _vm.refreshDynamic
    }
  })], 1) : _vm._e()] : _c('div', {
    staticClass: "no-detail"
  }, [_vm._v("无可用模块，请到"), _c('a', {
    on: {
      "click": function($event) {
        _vm.goToAppStore('/application/list')
      }
    }
  }, [_vm._v("模板管理")]), _vm._v("中启用！")])], 2)]), _vm._v(" "), _c('span', {
    staticClass: "detailClose",
    on: {
      "click": _vm.closeDetail
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.detailShow) ? _c('detail', {
    ref: "detail",
    attrs: {
      "moduleName": _vm.detailName,
      "id": _vm.detailId
    },
    on: {
      "close": _vm.closeChild,
      "refresh": function($event) {
        _vm.getDetail()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.detailShow) ? _c('div', {
    staticClass: "detail-bg",
    on: {
      "click": function($event) {
        _vm.detailShow = false
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.addnewShow) ? _c('add-new', {
    ref: "addNew",
    attrs: {
      "modal": false,
      "addnewProp": _vm.addnewProp
    },
    on: {
      "closeForDetail": function($event) {
        _vm.addnewShow = false
      },
      "refresh": _vm.getList,
      "callback": _vm.adnewCB,
      "communicatePlan": _vm.addPlan,
      "closeConfirm": _vm.closeConfirm,
      "changeOppStage": _vm.jumpStage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.remindShow) ? _c('remind', {
    attrs: {
      "modal": false,
      "customer": _vm.remindProps,
      "moduleName": _vm.moduleName
    },
    on: {
      "refresh": _vm.getList,
      "closeDialog": function($event) {
        _vm.remindShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dialModalShow) ? _c('dial-modal', {
    attrs: {
      "dialStyle": _vm.dialStyle,
      "phoneList": _vm.phoneList
    },
    on: {
      "closeModal": function($event) {
        _vm.dialModalShow = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.remindShow),
      expression: "remindShow"
    }],
    staticClass: "v-modal"
  }), _vm._v(" "), (_vm.planShow) ? _c('customer-plan', {
    attrs: {
      "listData": _vm.planData,
      "selectVisitPlan": _vm.selectVisitPlan,
      "isItem": true
    },
    on: {
      "close": function($event) {
        _vm.planShow = false
      },
      "visitPlanSave": _vm.visitPlanSave
    }
  }) : _vm._e(), _vm._v(" "), (_vm.choosePrintType) ? _c('Print', {
    attrs: {
      "entityIdProp": _vm.id,
      "moduleName": _vm.moduleName,
      "templateIdProp": _vm.templateMsg.templateId,
      "refType": _vm.templateMsg.refType
    },
    on: {
      "closeDialog": _vm.closePrint
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.loseCauseShow) ? _c('lose-cause', {
    attrs: {
      "loseCauseShow": _vm.loseCauseShow,
      "oppId": _vm.opportunityId,
      "code": _vm.currentCode,
      "nextCode": _vm.nextOppCode,
      "flag": _vm.flag
    },
    on: {
      "refresh": _vm.getList,
      "close": function($event) {
        _vm.loseCauseShow = false
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.loseBecauseShow) ? _c('lose-because', {
    attrs: {
      "customerId": _vm.id,
      "templateId": _vm.templateId
    },
    on: {
      "refresh": _vm.refreshCustomerStage,
      "close": function($event) {
        _vm.loseBecauseShow = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "question",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "web-icon-information"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e0326f9","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/list/detail.vue
// module id = 1285
// module chunks = 82